module.exports = __webpack_public_path__ + "img/y10.17019a14.webp";